import { render, staticRenderFns } from "./ed-block-item.component.vue?vue&type=template&id=04bfb83c&scoped=true&"
import script from "./ed-block-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-block-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-block-item.component.scss?vue&type=style&index=0&id=04bfb83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfb83c",
  null
  
)

export default component.exports